/* поля, используемые при валидации */
export enum ValidationEnum {
	diarization = 'diarization',
	engine_diarization = 'engine_diarization',
	merge_all_to_one_audio = 'merge_all_to_one_audio',
}
